// @ts-nocheck
import Multiselect from '@rio-cloud/rio-uikit/Multiselect';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { pdcFetchInspections, setFilter } from '@/actions/pdcActions';
import {
    PDC_CONDITION_OVERDUE,
    PDC_SEVERITY_HIGH,
    PDC_SEVERITY_LOW,
    PDC_SEVERITY_MEDIUM,
    VEHICLE_CONDITION_FILTER,
} from '@/constants';
import { getPDCIsLoading } from '@/selectors';

const isOptionSelected = (filters, item) => filters.indexOf(item) > -1;

const VehicleConditionFilter = ({ filters, isLoading, onVehicleConditionFilterChange }) => {
    const enabledVehicleConditionFilters = filters
        .filter(entry => entry.filterType === VEHICLE_CONDITION_FILTER)
        .map(entry => entry.item);

    const vehicleConditionOptions = [
        {
            id: PDC_SEVERITY_LOW,
            label: <FormattedMessage id='intl-msg:filter.vehicle_condition.severity.LOW' />,
            icon: <i className='uikit-icon icon-check-badge text-color-success margin-top--1' />,
            selected: isOptionSelected(enabledVehicleConditionFilters, PDC_SEVERITY_LOW),
        },
        {
            id: PDC_CONDITION_OVERDUE,
            label: <FormattedMessage id='intl-msg:filter.vehicle_condition.OVERDUE' />,
            icon: <i className='uikit-icon icon-time text-color-info margin-top--1' />,
            selected: isOptionSelected(enabledVehicleConditionFilters, PDC_CONDITION_OVERDUE),
        },
        {
            id: PDC_SEVERITY_MEDIUM,
            label: <FormattedMessage id='intl-msg:filter.vehicle_condition.severity.MEDIUM' />,
            icon: <i className='uikit-icon icon-warning-sign text-color-warning margin-top--2' />,
            selected: isOptionSelected(enabledVehicleConditionFilters, PDC_SEVERITY_MEDIUM),
        },
        {
            id: PDC_SEVERITY_HIGH,
            label: <FormattedMessage id='intl-msg:filter.vehicle_condition.severity.HIGH' />,
            icon: <i className='uikit-icon icon-error-sign text-color-danger margin-top--2' />,
            selected: isOptionSelected(enabledVehicleConditionFilters, PDC_SEVERITY_HIGH),
        },
    ];

    return (
        <Multiselect
            placeholder={<FormattedMessage id='intl-msg:filter.placeholder' />}
            options={vehicleConditionOptions}
            // also updates the selection when an overview tile changes the filter
            value={enabledVehicleConditionFilters}
            onChange={onVehicleConditionFilterChange}
            isLoading={isLoading}
            showSelectedItemIcon
            showUnselectedItemIcons
            dropdownClassName='min-width-200'
        />
    );
};

VehicleConditionFilter.propTypes = {
    isLoading: PropTypes.bool,
    filters: PropTypes.array.isRequired,
    onVehicleConditionFilterChange: PropTypes.func,
};

export const useVehicleConditionFilterChange = () => {
    const dispatch = useDispatch();
    return items => {
        dispatch(setFilter(VEHICLE_CONDITION_FILTER, items));
        dispatch(pdcFetchInspections());
    };
};

const ConnectedVehicleConditionFilter = props => {
    const isLoading = useSelector(getPDCIsLoading);
    const onVehicleConditionFilterChange = useVehicleConditionFilterChange();

    return (
        <VehicleConditionFilter
            {...props}
            isLoading={isLoading}
            onVehicleConditionFilterChange={onVehicleConditionFilterChange}
        />
    );
};

export { VehicleConditionFilter };
export default ConnectedVehicleConditionFilter;
